/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createDataActionHook, IActionContext, IActionInput, IMSDyn365Window } from '@msdyn365-commerce/core';
import { Cart, CartLine } from '@msdyn365-commerce/retail-proxy';
import { IProductInfo, TelemetryEvent } from '@msdyn365-commerce/telemetry-internal';

declare var window: IMSDyn365Window;

const beforeCopyCart = async (inputs: IActionInput | IActionInput[]) => {
    // placeholder
};

const afterCopyCart = async (_inputs: IActionInput | IActionInput[], cart: Cart | Cart[], actionContext: IActionContext) => {
    if (window && window._msdyn365 && window._msdyn365.telemetry) {
        // TODO (Matt D 4/8/20): Adding product conversion here as workaround for CheckOut bug. Will revisit in user story 6963863
        const cartObject = Array.isArray(cart) ? cart[0] : cart;
        const cartLineProductUnits: IProductInfo[] = [];
        if (cartObject && cartObject.CartLines && Array.isArray(cartObject.CartLines) && cartObject.CartLines.length > 0) {
            cartObject.CartLines.forEach((cartLineitem: CartLine) => {
                if (cartLineitem.ProductId) {
                    // The product id in cartLine actually contains recordId and not master product id so we can use it up here to lookup product.
                    const productInfo = <IProductInfo>actionContext.requestContext.telemetryData[cartLineitem.ProductId];
                    if (productInfo) {
                        cartLineProductUnits.push({
                            productChannelId: cartObject.ChannelId ? cartObject.ChannelId.toString() : '',
                            productChannelName: '',
                            productCategoryId: '',
                            productCategoryName: '',
                            productId: productInfo.productId,
                            productName: productInfo.productName,
                            productSku: productInfo.productSku,
                            productPrice: cartLineitem.Price ? cartLineitem.Price.toString() : '',
                            productQuantity: cartLineitem.Quantity ? cartLineitem.Quantity.toString() : '',
                            productCurrency: actionContext.requestContext.channel ? actionContext.requestContext.channel.Currency || '' : ''
                        });
                    }
                }
            });
        }

        window._msdyn365.telemetry.logEvent(TelemetryEvent.CheckOut, {
            cartId: cartObject.Id,
            cartVersion: cartObject.Version ? cartObject.Version.toString() : '',
            products: cartLineProductUnits,
            orderId: cartObject.OrderNumber ? cartObject.OrderNumber.toString() : ''
        });
    }
};

createDataActionHook({
    actionId: '@msdyn365-commerce/retail-proxy/Carts/Copy',
    postReaderHook: afterCopyCart,
    preReaderHook: beforeCopyCart
});
